<template>
  <div>
    <div class="wrap" :class="{ 'is-preview': type === 'preview' }">
      <el-form
        :model="formData"
        ref="form"
        :rules="type === 'preview' ? null : rules"
        label-suffix="："
        :label-width="type === 'preview' ? null : 'auto'"
        label-position="left"
      >
        <div>
          <div class="title title-mb">
            <div class="title-block">
              <div class="block"></div>
              <div class="titleText">基本信息</div>
            </div>
          </div>
          <el-row :gutter="20">
            <el-col :span="12" :xs="12">
              <el-form-item prop="name" label="加工厂名称">
                <el-input v-model="formData.name" placeholder="请输入" v-if="type != 'preview'"></el-input>
                <span v-else>{{ formData.name ? formData.name : '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="12">
              <el-form-item prop="processUnitPrice" label="加工单价（元）">
                <el-input
                  type="number"
                  v-model="formData.processUnitPrice"
                  placeholder="请输入"
                  v-if="type != 'preview'"
                ></el-input>
                <span v-else>{{ formData.processUnitPrice ? formData.processUnitPrice : '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="12">
              <el-form-item label="加工厂地址" prop="parentFullCodeList">
                <div class="flex" v-if="type !== 'preview'">
                  <area-select
                    v-if="showarea && type !== 'preview'"
                    v-model="formData.parentFullCodeList"
                    :data="$pcaa"
                    :level="2"
                    @change="handleRegionChange"
                  ></area-select>
                </div>
                <span v-else>{{ formData.parentFullName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="12">
              <el-form-item prop="locDetails" label="详细地址">
                <el-input
                  id="tipinput"
                  v-model="formData.locDetails"
                  placeholder="请输入"
                  v-if="type != 'preview'"
                ></el-input>
                <span v-else>{{ formData.locDetails ? formData.locDetails : '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12" :xs="12">
              <el-form-item label="联系人">
                <el-input v-model="formData.ownerName" placeholder="请输入" v-if="type != 'preview'"></el-input>
                <span v-else>{{ formData.ownerName ? formData.ownerName : '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="12">
              <el-form-item prop="ownerContact" label="联系方式">
                <el-input v-model="formData.ownerContact" placeholder="请输入" v-if="type != 'preview'"></el-input>
                <span v-else>{{ formData.ownerContact ? formData.ownerContact : '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="12">
              <el-form-item label="发票抬头">
                <el-input
                  v-model="formData.businessInformationName"
                  placeholder="请输入"
                  v-if="type != 'preview'"
                ></el-input>
                <span v-else>{{ formData.businessInformationName ? formData.businessInformationName : '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="12">
              <el-form-item label="纳税人识别号">
                <el-input v-model="formData.taxpayerRegNo" placeholder="请输入" v-if="type != 'preview'"></el-input>
                <span v-else>{{ formData.taxpayerRegNo ? formData.taxpayerRegNo : '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24" :xs="24">
              <el-form-item label="备注">
                <el-input
                  type="textarea"
                  :rows="3"
                  show-word-limit
                  :maxlength="300"
                  placeholder="300字以内"
                  v-model="formData.remark"
                  v-if="type != 'preview'"
                ></el-input>
                <span v-else>{{ formData.remark ? formData.remark : '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div>
          <div class="title title-mb">
            <div class="title-block">
              <div class="block"></div>
              <div class="titleText">收款账户</div>
              <el-button v-if="type !== 'preview'" class="line-button" icon="el-icon-plus" @click="handleAddRow"
                >新增行</el-button
              >
            </div>
          </div>

          <TablePublic
            :colLists="colLists"
            :tableData="formData.bankList"
            :paginationFlag="false"
            :nonMargin="true"
            :headerCellClassMethod="addStar"
          >
            <template slot="solts" slot-scope="scope" v-if="type !== 'preview'">
              <el-button class="delbutton" type="text" size="small" @click="handleDel(scope.index)">删除</el-button>
            </template>
            <template slot="bankName" slot-scope="scope">
              <el-form-item :prop="'bankList.' + scope.index + '.bankName'" :rules="rules.bankName">
                <el-input v-if="type !== 'preview'" v-model="scope.data.bankName" placeholder="请输入"></el-input>
                <span v-else>{{ scope.data.bankName }}</span>
              </el-form-item>
            </template>
            <template slot="bankAccount" slot-scope="scope">
              <el-form-item
                :prop="'bankList.' + scope.index + '.bankAccount'"
                :rules="rules.bankAccount"
                :show-message="false"
              >
                <el-input
                  v-if="type !== 'preview'"
                  v-model="scope.data.bankAccount"
                  @blur="handleBankAccount(scope.data)"
                  placeholder="请输入"
                ></el-input>
                <span v-else>{{ scope.data.bankAccount }}</span>
              </el-form-item>
            </template>
          </TablePublic>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
import TablePublic from '@/components/tablePublic.vue'

import { toGapStr } from '@/utils/common'
import { isPhone } from '@/utils/validate'

export default {
  name: 'FactoryForm',
  components: {
    TablePublic,
  },
  props: {},
  data() {
    return {
      type: '',
      showarea: false,
      selectedArea: [],
      areaOptions: regionData,
      colLists: [
        {
          prop: 'bankName',
          label: '开户行',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'bankAccount',
          label: '银行账号',
          isTrue: true,
          formSolt: true,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      formData: {
        parentFullCodeList: [],
        name: '',
        code: '',
        parentFullName: '',
        level: 6,
        bankList: [],
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        locDetails: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        ownerContact: [{ validator: isPhone, trigger: ['blur', 'change'] }],
        processUnitPrice: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        businessInformationName: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        taxpayerRegNo: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        parentFullCodeList: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
      },
      productName: [],
      selected: [],

      geocoder: null,
    }
  },
  created() {},
  mounted() {},
  methods: {
    //根据地址获取经纬度
    getGeoCode(location) {
      const cityCode = this.formData.parentFullCodeList[1]
      this.geocoder = new AMap.Geocoder({
        city: '江门市', 
      })

      this.geocoder.getLocation('江门市', (status, result) => {
        if (status === 'complete' && result.geocodes.length) {
          // result为对应的地理位置信息
          console.log(result, 'result')
          this.formData.latitude = result.geocodes[0].location.lat
          this.formData.longitude = result.geocodes[0].location.lng
        }
      })
    },
    //POI搜索
    initAutoComplete() {
      //输入提示
      var autoOptions = {
        input: 'tipinput',
        citylimit: true,
        city: this.formData.parentFullCodeList[1],
      }

      var auto = new AMap.AutoComplete(autoOptions)
      // var placeSearch = new AMap.PlaceSearch({
      //   map: this.map,
      // }) //构造地点查询类
      auto.on('select', (e) => {
        console.log(e, '---e')
        // placeSearch.setCity(e.poi.adcode)
        // placeSearch.search(e.poi.name) //关键字查询查询

        this.formData.latitude = e.poi.location?.lat
        this.formData.longitude = e.poi.location?.lng
        this.formData.locDetails = e.poi.name
        // this.formData.locDetails = e.poi.address
      }) //注册监听，当选中某条记录时会触发
    },
    handleBankAccount(row) {
      row.bankAccount = toGapStr(row.bankAccount)
    },
    handleRegionChange(n) {
      this.$refs.form.clearValidate('parentFullCodeList')

      const provinceText = this.codeToText('area', n[0], '86')
      const cityText = this.codeToText('area', n[1], n[0])
      const districtText = this.codeToText('area', n[2], n[1])
      const streetText = this.codeToText('area', n[3], n[2])
      this.formData.parentFullName = `${provinceText}${cityText}${districtText}${streetText}`
      this.formData.cnProvinceName = provinceText
      this.formData.provinceCode = n[0]
      this.formData.cnCityName = cityText
      this.formData.cityCode = n[1]
      this.formData.cnDistrictName = districtText
      this.formData.districtCode = n[2]
    },
    handleDel(index) {
      this.formData.bankList.splice(index, 1)
    },
    addStar(obj) {
      // if (this.type != 'preview') {
      //   if (obj.columnIndex === 1 || obj.columnIndex === 3) {
      //     return 'star'
      //   }
      // }
    },
    handleAddRow() {
      this.formData.bankList.push({
        bankName: '',
        bankAccount: '',
      })
    },
    reset() {
      this.formData = {
        parentFullCodeList: [],
        name: '',
        parentFullName: '',
        level: 6,
        code: '',
      }
      this.showarea = false
      this.resetForm('form')
    },
    add(type) {
      console.log('adddddddddd')
      this.type = type
      this.formData.parentFullCodeList = ['440000', '440700', '440705']
      this.showarea = true

      this.initAutoComplete()
    },
    getDetail(row, type) {
      this.type = type
      this.showarea = true
      this.formData = { ...row }
      this.formData.parentFullCodeList = [row.provinceCode, row.cityCode, row.districtCode]
      this.formData.parentFullName =
        row.cnProvinceName === row.cnCityName
          ? `${row.cnProvinceName}${row.cnDistrictName}`
          : `${row.cnProvinceName}${row.cnCityName}${row.cnDistrictName}`
      console.log(this.formData, 'this.formDatathis.formDatathis.formData---------------')

      if (type === 'preview') {
        this.colLists[this.colLists.length - 1].isTrue = false
      }
      // this.formData.parentFullCodeList = row.parentFullCodeList
      // this.formData.name = row.name
      // this.formData.parentFullName = row.parentFullName
      // this.formData.level = row.level
      // this.formData.id = row.id

      this.initAutoComplete()
    },
    codeToText(fieldName, code, parentCode) {
      let name = ''
      switch (fieldName) {
        case 'area':
          for (let keyCode in this.$pcaa[parentCode]) {
            if (code == keyCode) {
              name = this.$pcaa[parentCode][keyCode]
              break
            }
          }
          return name
        case 'village':
          for (let i = 0; i < this.villageList.length; i++) {
            if (code == this.villageList[i].code) {
              name = this.villageList[i].name
              break
            }
          }
          return name
        case 'field':
          for (let i = 0; i < this.fieldList.length; i++) {
            if (code == this.fieldList[i].code) {
              name = this.fieldList[i].name
              break
            }
          }
          return name
      }
    },
    submit(type) {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            resolve({ 
              ...this.formData, 
              type: '2', //1:客户,2:供应商,3:当前企业 
            })
          } else {
            reject()
          }
        })
      })
    },
    handleAreaChange(value) {
      console.log(value, '------------------------------------')
      const text =
        CodeToText[value[0]] + '-' + CodeToText[value[1]] + '-' + CodeToText[value[2]] + '-' + CodeToText[value[3]]
      console.log(text, '-------------------text')
    },
  },
}
</script>

<style scoped lang="less">
@import '../../../../assets/form.less';
.wrap {
  height: 300px;
}
/deep/ .el-input--suffix .el-input__inner {
  width: 373px;
}
.left {
  margin-left: 10px;
}
/deep/ .flex {
  .el-input--suffix .el-input__inner {
    width: 127px;
  }
}
/deep/.area-select-wrap .area-select {
  margin-left: 0px;
  // margin-right: 10px;
}
// .area-select.medium

/deep/ .area-select.medium {
  width: 110px;
  height: 39px;
}
/deep/ .area-select-wrap {
  display: flex;
}
/deep/ .area-select .area-selected-trigger {
  padding: 0 0 0 10px;
}
.flex {
  display: flex;
}
.area-select {
  height: 38px;
}

::v-deep {
  .is-preview {
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item__label {
      color: #000;
    }
  }
}
</style>
<style>
.amap-sug-result {
  z-index: 999999 !important;
}
</style>
